module.exports = new __parcel__URL__("level_prog_shine.4121eaff.png").toString();